/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { jsx } from '@emotion/core'

import Icon from '../../ui/Icon/IconFactory'
import { getDefaultGradeStylesObj } from './grade.styles'
import { useSiteVars } from '../../themes/useSiteVars'

interface GradeProps {
    grade: string
    name: string
    metaA?: string
    metaB?: string
    metaC?: string
    innerContent?: string
    preview?: boolean
}

const Grade: FunctionalComponent<GradeProps> = ({ grade, name, metaA, metaB, metaC, innerContent, preview }) => {
    const siteVars = useSiteVars()
    const GradeStyles = getDefaultGradeStylesObj(siteVars, preview)

    const subText = metaA || metaB || metaC

    const dividerA = metaA && (metaB || metaC)
    const dividerB = metaB && metaC

    const color =
        (grade.includes('A') && 'rgb(0, 102, 0)') ||
        (grade.includes('B') && 'rgb(0, 153, 51)') ||
        (grade.includes('C') && 'rgb(204, 204, 0)') ||
        (grade.includes('D') && 'rgb(255, 153, 0)') ||
        (grade.includes('F') && 'rgb(204, 0, 0)') ||
        'rgb(153, 153, 153)'

    return (
        <Fragment>
            <div css={GradeStyles.root}>
                <div css={GradeStyles.headerWrapper}>
                    <h2 css={GradeStyles.header}>{name}</h2>

                    {subText && (
                        <div css={GradeStyles.subText}>
                            <span>{metaA}</span>
                            {dividerA && <span css={GradeStyles.divider}> | </span>}
                            <span>{metaB}</span>
                            {dividerB && <span css={GradeStyles.divider}> | </span>}
                            <span>{metaC}</span>
                        </div>
                    )}
                </div>
                {grade && (
                    <div css={GradeStyles.iconWrapper}>
                        <Icon icon="GradeBacker" fill={color} />
                        <span>{grade}</span>
                    </div>
                )}
            </div>
            {innerContent && (
                <div
                    css={GradeStyles.content}
                    // eslint-disable-next-line
                    dangerouslySetInnerHTML={{ __html: innerContent }}
                />
            )}
        </Fragment>
    )
}

export default Grade
